import { createRetryOn5xxInterceptor } from './retryOn5xx';

function isLoginPost(config) {
  return config?.url === '/v1/auth' && config?.method === 'post';
}

/**
 * Interceptor de retry para o login (POST /v1/auth).
 * Usa o interceptor genérico retryOn5xx com predicado isLoginPost.
 */
export function createLoginRetryInterceptor(axiosInstance, fallbackHandler) {
  return createRetryOn5xxInterceptor(axiosInstance, isLoginPost, fallbackHandler);
}
